<template>
  <a-table
    :rowKey="record => record.id"
    :columns="columns"
    :dataSource="data"
    :scroll="{ x: 1500 }"
    bordered
  >
    <template slot="Serial">{{ $t('business.label.serial') }}</template>
    <template slot="Item.name">{{ $t('business.label.itemName') }}</template>
    <template slot="First">{{ $t('business.label.modelFirst') }}</template>
    <template slot="Second">{{ $t('business.label.modelSecond') }}</template>
    <template slot="Third">{{ $t('business.label.modelThird') }}</template>
    <template slot="Fourth">{{ $t('business.label.modelFourth') }}</template>
    <template slot="DaysOfExpirationNearly">{{ $t('business.label.daysOfExpirationNearly') }}</template>
    <template slot="DaysOfProductionNearly">{{ $t('business.label.daysOfProductionNearly') }}</template>
    <template slot="DaysOfInspectionNearly">{{ $t('business.label.daysOfInspectionNearly') }}</template>
    <template slot="Available">{{ $t('business.label.available') }}</template>

    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>

    <span slot="available" slot-scope="text">
      <a-checkbox :checked="text" />
    </span>
    <!--根据商品名称/编号/助记码过滤-->
    <div
      slot="filterDropdown"
      slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
      style="padding: 8px"
    >
      <a-input
        v-ant-ref="c => searchInput = c"
        :value="selectedKeys[0]"
        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        style="width: 188px; margin-bottom: 8px; display: block;"
      />
      <a-button
        type="primary"
        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px">{{ $t('button.query') }}</a-button>
      <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">{{ $t('button.reset') }}</a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"/>
    <template slot="search" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight"
          >{{ fragment }}</mark
          >
          <template
            v-else
          >{{ fragment }}</template
          >
        </template>
      </span>
      <template
        v-else
      >{{ text }}</template
      >
    </template>

  </a-table>
</template>

<script>
import { exportToExcel } from '@/components/Excel/export/exportFunction'
import { excelName, filterVal, headerData } from '@/api/dto_js/import/itemModelBaseData'
import { transformData } from '@/api/dto_js/import/transform'
import { checkFieldType } from '@/utils/field-check'

export default {
    name: 'ItemModelBaseData',
    data() {
      return {
        data: [],
        // 表头
        columns: [
          {
            // fixed: 'left',
            scopedSlots: { customRender: 'serial', title: 'Serial',}
          },
          {
            dataIndex: 'item.name',
            scopedSlots: {
              customRender: 'search',
              title: 'Item.name',
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'},
            onFilter: (value, record) => record.item.name.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          },
          {
            dataIndex:'first',
            scopedSlots: { title: 'First' }
          },
          {
            dataIndex:'second',
            scopedSlots: { title: 'Second' }
          },
          {
            dataIndex:'third',
            scopedSlots: { title: 'Third' }
          },
          {
            dataIndex:'fourth',
            scopedSlots: { title: 'Fourth' }
          },
          {
            dataIndex: 'daysOfExpirationNearly',
            scopedSlots: { title: 'DaysOfExpirationNearly' }
          },
          {
            dataIndex: 'daysOfProductionNearly',
            scopedSlots: { title: 'DaysOfProductionNearly' }
          },
          {
            dataIndex: 'daysOfInspectionNearly',
            scopedSlots: { title: 'DaysOfInspectionNearly' }
          },
          {
            dataIndex: 'available',
            scopedSlots: { customRender: 'available' ,title:'Available'}
          },
        ],
        excelData:[],
        searchText: '',
        searchInput: null,
        searchedColumn: '',
      }
    },
    methods:{
      getData(data){
        this.data=data
      },
      handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset(clearFilters) {
        clearFilters();
        this.searchText = ''
      },
      exportData(){
        const list = JSON.parse(JSON.stringify(this.data))
        for (let x=0;x<list.length;x++){
          if(list[x].item){
            list[x].item=list[x].item.name
          }
        }
        exportToExcel(headerData,filterVal,list,excelName)
      },
      transformData(data){
        // item尚未转换
        const list = transformData(headerData, filterVal, data)
        // this.$message.info(JSON.stringify(list))
        for (let i = 0; i < list.length; i++) {
          if (list[i].item) {
            list[i].item = { name: list[i].item }
          }
        }
        this.data = list
      },
      // save(){
      //   this.data.forEach(item=>{
      //     item['id']=null
      //     item['version']=0
      //   })
      //   // this.$message.info(JSON.stringify(this.data))
      //   this.$emit('sendSave',this.data)
      // },
      save() {

        const arrModel = []

        this.data.forEach(item => {
          item['id'] = null
          item['version'] = 0

          const map = new Map()
          map.set('type', 'modelPersister')
          map.set('dataId', item.name)
          map.set('content', item)
          const returnValue = checkFieldType(map)
          arrModel.push(returnValue)
        })
        // this.$message.info(JSON.stringify(this.data))
        this.$emit('sendSave', arrModel)
      },
      clear() {
        this.data = []
      }
    }
  }
</script>

<style scoped>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>